import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const HOME_ORDER_DELIVERY_API_URL = `${API_HOST}/api/homeDeliveryOrder`;

function* getHomeDeliveryOrders() {
  yield takeEvery(actions.SEARCH_HOME_DELIVERY_ORDERS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${HOME_ORDER_DELIVERY_API_URL}/order?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.SEARCH_HOME_DELIVERY_ORDERS_ENDED });
    }
  });
}

function* updateHomeDeliveryOrder() {
  yield takeEvery(actions.UPDATE_HOME_DELIVERY_ORDER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${HOME_ORDER_DELIVERY_API_URL}/order/`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.UPDATE_HOME_DELIVERY_ORDER_END });
    }
  });
}

function* batchUpdateHomeDeliveryOrder() {
  yield takeEvery(actions.BATCH_UPDATE_HOME_DELIVERY_ORDER, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${HOME_ORDER_DELIVERY_API_URL}/order/batchUpdate`,
        data,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.BATCH_UPDATE_HOME_DELIVERY_ORDER_END });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getHomeDeliveryOrders),
    fork(updateHomeDeliveryOrder),
    fork(batchUpdateHomeDeliveryOrder),
  ]);
}
